import { callApiToServer } from "../callApi";

export async function searchVendorLinkup(
  authtoken,
  searchText,
  skipNumber,
  limitNumber
) {
  try {
    const header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authtoken,
    };

    const body = JSON.stringify({
      search_text: searchText,
    });
    const endUrl =
      "v1/auth/filter-vendor-linkup/" + skipNumber + "/" + limitNumber;
    const responseData = await callApiToServer(body, header, "POST", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
